module.exports = __webpack_public_path__ + "img/55.a36bc49f.svg";